/* This file was generated automatically. Do not edit manually. */

export enum AssistantReservationTimeState {
    Past = 'Past',
    CheckOutMissed = 'CheckOutMissed',
    ToBeCheckedOut = 'ToBeCheckedOut',
    CheckedIn = 'CheckedIn',
    CheckInMissed = 'CheckInMissed',
    ToBeCheckedIn = 'ToBeCheckedIn',
    Future = 'Future',
    ToBeConfirmed = 'ToBeConfirmed',
    ConfirmationMissed = 'ConfirmationMissed',
}
